import React from 'react'
import { Row, Col, Form } from 'antd'
import { Input, Radio } from 'ui/styled'
import { Label } from 'pages/Ticket/styled'
import AccumulatorIssueFieldsAttachment from './AccumulatorIssueFieldsAttachment'

const { TextArea } = Input
const { Group } = Radio
const { Item } = Form

const radioOptions = [
  { label: 'Issue', value: 'issue' }
  // request from Rishi to hide it for now NEX-25356
  // { label: 'Report', value: 'report' }
]

const AccumulatorIssueFields = ({ form, resource }) => (
  <>
    <Row>
      <Col span={11}>
        <Label>Request Type</Label>
        <Item name="request_type" rules={[{ required: true }]}>
          <Group options={radioOptions} />
        </Item>
      </Col>
      <Col span={11} offset={1}>
        <Label>Description</Label>
        <Item name="description" rules={[{ required: true }]}>
          <TextArea autoSize={{ minRows: 3, maxRows: 6 }} />
        </Item>
      </Col>
    </Row>
    <AccumulatorIssueFieldsAttachment form={form} resource={resource} />
  </>
)

export default AccumulatorIssueFields
